module.exports = __webpack_public_path__ + "assets/veritas_slider3.c70346fa.jpg";